var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-section-title',{attrs:{"title":"Calendars","loading":_vm.isLoading}}),(_vm.calendar)?_c('router-view',{attrs:{"loading":_vm.isLoading,"calendar":_vm.calendar}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }